import type { Direction } from "../domain/types";

export function swipeDirection(
  start: { x: number; y: number },
  end: { x: number; y: number },
  threshold = 30,
): Direction | undefined {
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  if (Math.max(Math.abs(dx), Math.abs(dy)) < threshold) return undefined;
  if (Math.abs(dx) > Math.abs(dy)) return dx > 0 ? "right" : "left";
  return dy > 0 ? "down" : "up";
}
